import React from 'react';
import { FormattedMessage } from 'react-intl-next';
import messages from '../../common/utils/messages';
import { LinkButton } from '@atlaskit/button/new';
import { type UIAnalyticsEvent } from '@atlaskit/analytics-next';
import { NAVIGATION_CHANNEL, UI_EVENT_TYPE } from '../../common/utils/analytics';

type ManageButtonProps = {
	href: string;
};

export default class ManageButton extends React.Component<ManageButtonProps> {
	onClick = (_: React.MouseEvent<HTMLElement>, analyticsEvent: UIAnalyticsEvent) => {
		analyticsEvent
			.update({
				eventType: UI_EVENT_TYPE,
				actionSubjectId: 'manageListButton',
			})
			.fire(NAVIGATION_CHANNEL);
	};

	render() {
		const { href } = this.props;
		return (
			<LinkButton href={href} onClick={this.onClick} testId="app-switcher-manage-button">
				<FormattedMessage {...messages.manageList} />
			</LinkButton>
		);
	}
}
